<template>
  <!-- Temporarily disabled -->
  <div v-if="false" class="language-switcher">
    <div class="dropdown">
      <button 
        class="dropdown-toggle"
        type="button"
        @click="toggleDropdown"
        aria-haspopup="true"
        :aria-expanded="isOpen"
      >
        <i class="ti ti-language"></i>
        <span>{{ getCurrentLanguageName }}</span>
      </button>
      <ul class="dropdown-menu dropdown-menu-end" :class="{ show: isOpen }">
        <li>
          <a class="dropdown-item" href="#" @click.prevent="changeLocale('en')" :class="{ active: currentLocale === 'en' }">
            <span class="fi fi-us me-2"></span>
            English
          </a>
        </li>
        <li>
          <a class="dropdown-item" href="#" @click.prevent="changeLocale('tr')" :class="{ active: currentLocale === 'tr' }">
            <span class="fi fi-tr me-2"></span>
            Türkçe
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { locale } = useI18n();
    const currentLocale = ref(locale.value);
    const isOpen = ref(false);
    
    const getCurrentLanguageName = computed(() => {
      switch (currentLocale.value) {
        case 'en':
          return 'English';
        case 'tr':
          return 'Türkçe';
        default:
          return 'English';
      }
    });
    
    const toggleDropdown = () => {
      isOpen.value = !isOpen.value;
    };
    
    const closeDropdown = (event) => {
      // Close dropdown when clicking outside
      if (!event.target?.closest('.language-switcher')) {
        isOpen.value = false;
      }
    };
    
    const changeLocale = (lang) => {
      locale.value = lang;
      currentLocale.value = lang;
      localStorage.setItem('locale', lang);
      isOpen.value = false; // Close dropdown after selection
    };
    
    // Add/remove event listeners
    const handleLocaleChange = (event) => {
      if (event.detail?.locale) {
        currentLocale.value = event.detail.locale;
      }
    };
    
    onMounted(() => {
      document.addEventListener('click', closeDropdown);
      document.addEventListener('locale-changed', handleLocaleChange);
    });
    
    onUnmounted(() => {
      document.removeEventListener('click', closeDropdown);
      document.removeEventListener('locale-changed', handleLocaleChange);
    });
    
    return {
      currentLocale,
      isOpen,
      toggleDropdown,
      changeLocale,
      getCurrentLanguageName
    };
  }
};
</script>

<style scoped>
.language-switcher {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.language-switcher .dropdown {
  position: relative;
}

.language-switcher button {
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 50px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

.language-switcher button:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  background-color: #f8f9fa;
}

.language-switcher .dropdown-menu {
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-bottom: 5px;
  min-width: 150px;
  border-radius: 8px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid #eee;
  padding: 0.5rem 0;
  background-color: #fff;
  display: none;
}

.language-switcher .dropdown-menu.show {
  display: block;
}

.language-switcher .dropdown-item {
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #212529;
}

.language-switcher .dropdown-item.active {
  background-color: #e9ecef;
  color: #000;
}

.language-switcher .dropdown-item:hover {
  background-color: #f8f9fa;
}
</style> 